import { gql } from '@apollo/client';

const GET_ASSETS = gql`
  query getAssets {
    assets {
      onLawId
      productName
      productCode
      quantity
      usageEndDate
    }
  }
`;

export default GET_ASSETS;
